import React, { Component } from 'react'
import { connect } from 'react-redux';
import Graphics from 'components/tipBox/Graphics';

import './TipBox.scss'

import { tipBoxOpen } from '../../actions';

import { withTranslation } from 'react-i18next'

class TipBox extends Component {

  toggleBoxClosed = () => {
    this.props.tipBoxOpen(
      {
        id: this.props.id,
        open: !this.props.open
      }
    );
  }

  render() {
    return (
      <ul>
        <li
          draggable
          onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.toggleBoxClosed(e)} }
          tabIndex={0}
          id={"TipBox_"+this.props.type+"_"+this.props.id}
          className={'TipBox draggable dropTarget'+((this.props.open)?' open':'')}
          style={{ transform: "translate3d(0px, 0px, 0px) rotateZ(0deg)" }}>
          <p aria-hidden="true" className="label">{this.props.t(this.props.type+" Tips")}</p>
          <Graphics id={this.props.id} />
        </li>
      </ul>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    id: ownProps.id,
    type: ownProps.type,
    open: state.tipBox.tipBoxes[ownProps.id-1].open // set to closed
  }
}

export default connect(mapStateToProps, {
  tipBoxOpen
})(withTranslation()(TipBox));
